import classNames from 'classnames';
import { observer } from 'mobx-react';
import { FC, ReactElement, useMemo } from 'react';
import { previousOrderProductUnavailableMessage } from '../../helpers/previousOrderModal';
import { previousOrderModalStore } from '../../store/previousOrderModalStore';
import { PreviousOrderModalProductExclusions } from '../PreviousOrderModalProductExclusions/PreviousOrderModalProductExclusions';
import { PreviousOrderModalProductItems } from '../PreviousOrderModalProductItems/PreviousOrderModalProductItems';
import { PreviousOrderModalProductModifiers } from '../PreviousOrderModalProductModifiers/PreviousOrderModalProductModifiers';
import { localeStore } from 'src/mobx/localesStore';
import { IOrderProduct } from 'src/types/orders';
import { formatPriceSettings } from 'src/utils/formatter';
import { getTranslate } from 'src/utils/helpers';
import Image from 'src/view/components/Image/Image';
import './style.scss';

interface IProps {
  product: IOrderProduct;
}

export const PreviousOrderModalProduct: FC<IProps> = observer(({ product }: IProps): ReactElement => {
  const productUnavailableMessage = useMemo((): string | null => previousOrderProductUnavailableMessage(product), [product]);

  return (
    <div className="previous-order-modal-product">
      <Image src={product.image} aspectRatio={1.5} wrapperClassName="previous-order-modal-product__image" />

      <div className="d-flex flex-column flex-1">
        {productUnavailableMessage ? (
          <p className="previous-order-modal-product__unavailable-msg letter-spacing-12">{localeStore.t(productUnavailableMessage)}</p>
        ) : null}

        <div className={classNames('d-flex flex-row justify-content-between flex-1', { 'opacity-50': productUnavailableMessage })}>
          <div className="d-flex flex-column">
            <p className="previous-order-modal-product__name">{getTranslate(product.name)}</p>

            <PreviousOrderModalProductModifiers modifiers={product.modifiers} />
            <PreviousOrderModalProductExclusions exclusions={product.exclusions} />
            <PreviousOrderModalProductItems product={product} />
          </div>

          <p className="previous-order-modal-product__price">{formatPriceSettings(product.price, previousOrderModalStore.currencySettings)}</p>
        </div>
      </div>
    </div>
  );
});
